const type = (val) => Object.prototype.toString.call(val).replace(/\[object\s(\w+)\]/g,($0,$1) => $1);

export default type;


// WEBPACK FOOTER //
// ./src/common/bare-metal/type.js